module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-341-retro-min.265ca172.jpg";